// Convert a string to propercase ("march" -> "March", "jean jacques" -> "Jean Jacques")
const properCase = (str = '') => {
	return str.replace(/\w\S*/g, (txt) => {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

export default properCase;
